<template>
  <div class="forma-sticky">
    <div class="traka" :class="{ 'bez-tabova': !$slots.tabovi }">
      <div class="avatar">{{ inicijali }}</div>
      <div>
        <div class="naslov">{{ naslov }}</div>
        <div class="pod">{{ podnaslov }}</div>
      </div>
      <div class="razmak"></div>
      <div class="stanja">
        <span v-if="!okvir.brojIzmjena" class="znak cisto">nema izmjena</span>
        <span v-else class="znak izmjene">● nespremljene izmjene ({{ okvir.brojIzmjena }})</span>
        <button v-if="okvir.brojGresaka" type="button" class="znak greske" title="Skoči na prvo polje s greškom" @click="okvir.skociNaPrvu()">
          {{ okvir.brojGresaka }} {{ okvir.brojGresaka === 1 ? 'greška' : 'grešaka' }} — idi na prvu ›
        </button>
        <span v-if="okvir.brojUpozorenja" class="znak upoz">{{ okvir.brojUpozorenja }} upozorenja</span>
      </div>
      <div class="akcije">
        <v-btn small depressed class="gumb-bijeli" :loading="spremanje" :disabled="spremanje" @click="$emit('spremi')">{{ spremiOznaka }}</v-btn>
        <v-btn small outlined dark class="gumb-duh" @click="$emit('odustani')">{{ odustaniOznaka }}</v-btn>
        <v-btn small outlined dark class="gumb-duh" @click="$emit('stari-obrazac')">
          <v-icon small left>mdi-undo-variant</v-icon>Stari obrazac
        </v-btn>
      </div>
    </div>
    <slot name="tabovi"></slot>
  </div>
</template>

<script>
// Sticky plava traka: naslov, značke (izmjene / greške / upozorenja) i gumbi. Mora biti unutar FormaOkvir.
export default {
  name: 'FormaTraka',
  inject: ['okvir'],
  props: {
    naslov: { type: String, default: '' },
    podnaslov: { type: String, default: '' },
    inicijali: { type: String, default: '' },
    spremanje: { type: Boolean, default: false },
    spremiOznaka: { type: String, default: 'Spremi' },
    odustaniOznaka: { type: String, default: 'Odustani' }
  }
}
</script>
